import { ClipboardList } from 'lucide-react'
import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import InventairesTab from '@features/stock/components/InventairesTab'

export const Route = createFileRoute('/_app/stock/inventaires')({
  staticData: {
    title: 'Inventaires',
    icon: ClipboardList,
    tab_icon: ClipboardList,
    permission: 'stock.inventaires.view',
    module: 'stock',
    section: 'Stock',
    order: 49,
     showInTab: true,
     showInNav: true,
     showInBreadcrumb: true,
  },
  loader: requirePermission('stock.inventaires.view'),
  component: InventairesTab,
})
